module.exports = __webpack_public_path__ + "img/10t.f21c3bcd.jpg";